<!-- 设备批量修改 -->
<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
    <el-form ref="editForm" :model="device" label-width="100px" :rules="validateRules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="设备编号" prop="deviceCode">
            <el-input type="text" v-model="device.deviceCode" disabled maxlength="15"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备类型" prop="deviceType">
            <code-select v-model="device.deviceType" code-type="DEVICE_TYPE"></code-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="所属单位" prop="compId">
            <comp-select v-model="device.compId" :remote="false"></comp-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="所属区域" prop="townCode">
            <area-cascader v-model="areaCodes"></area-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="进风风机" prop="inFanCount">
            <el-input-number v-model="device.inFanCount" :min="1" :max="100" :precision="0"></el-input-number>&nbsp;台
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出风风机" prop="outFanCount">
            <el-input-number v-model="device.outFanCount" :min="1" :max="100" :precision="0"></el-input-number>&nbsp;台
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="空调数量" prop="acCount">
            <el-input-number v-model="device.acCount" :min="1" :max="100" :precision="0"></el-input-number>&nbsp;台
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="空调总功率" prop="acPower">
            <el-input-number v-model="device.acPower" :min="1" :precision="0"></el-input-number>&nbsp;W
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否启用" prop="valid">
            <el-switch v-model="device.valid"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button type="default" @click="close">取消</el-button>
      <el-button type="primary" @click="save" icon="fa fa-save">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import CompSelect from "@/components/base/CompSelect";
import AreaCascader from "@/components/base/AreaCascader";
import CodeRadioGroup from "@/components/base/CodeRadioGroup";
import CodeSelect from "@/components/base/CodeSelect.vue";

export default {
  components: {CodeSelect, CodeRadioGroup, AreaCascader, CompSelect},
  extends: BaseVue,
  props: {
    device: {
      required: true
    }
  },
  data() {
    return {
      mapVisible: false,
      areaCodes: [],
      validateRules: {
        deviceCode: [{required:true, message:'设备编码不能为空', trigger: 'blur'}],
        compId: [{required:true, message:'所属单位不能为空', trigger: 'blur'}],
        townCode: [{required:true, message:'所属区域不能为空', trigger: 'blur'}],
        inFanCount: [{required:true, message:'进风风机数量不能为空', trigger: 'blur'}],
        outFanCount: [{required:true, message:'出风风机数量不能为空', trigger: 'blur'}],
        acCount: [{required:true, message:'空调数量不能为空', trigger: 'blur'}],
        acPower: [{required:true, message:'空调总功率不能为空', trigger: 'blur'}]
      }
    }
  },
  created() {
    if(this.device.provCode) {
      this.areaCodes.push(this.device.provCode);
    }
    if(this.device.cityCode) {
      this.areaCodes.push(this.device.cityCode);
    }
    if(this.device.townCode) {
      this.areaCodes.push(this.device.townCode);
    }
  },
  methods: {
    close(){
      this.$emit("close");
    },
    save(){
      this.device.provCode = this.areaCodes[0];
      this.device.cityCode = this.areaCodes[1];
      this.device.townCode = this.areaCodes[2];
      let editForm = this.$refs["editForm"];
      editForm.validate((yes)=>{
        if(yes){
          this.loading = true;
          this.postForm("/device/saveDevice", this.device, true).then(dr => {
            this.$emit("save", dr.bean);
          }).finally(()=>{
            this.loading = false;
          });
        }
      })
    },
    onPositionChange(point) {
      this.device.lng = point.lng;
      this.device.lat = point.lat;
      this.mapVisible = false;
    }
  }
}
</script>
<style lang="scss" scoped>
</style>